import React from 'react';
import PropTypes from 'prop-types';

import { partnerReturnUrl } from 'ggApp/modules/store/selectors';

import { Header, Wrap, PartnerLogo, DesktopLogo, MobileLogo, NaviInfoIcon } from './styles';

const CheckoutHeader = ({
    order: { items },
    isPartnerStore,
    naviLogo,
    naviTrigger,
    storeActive: { logo_url: logo, code, activeLanguage },
    theme,
    isMobileUser,
}) => {
    const { variant = {} } = (items && items[0]) || {};
    const variantId = variant.id;
    const LogoComponent = isMobileUser ? MobileLogo : DesktopLogo;
    const renderBackToStoreLinkWithLogo = () => {
        const storeCode = code || 'de';
        const langCode = activeLanguage || 'de';
        const partnerReturnLink = variantId ? partnerReturnUrl(storeCode, variantId) : '/';
        const LogoImage =
            isPartnerStore && variantId ? (
                <PartnerLogo alt="logo" src={logo} />
            ) : (
                <LogoComponent color={theme.colors.Color1} />
            );
        if (isPartnerStore) {
            return <a href={partnerReturnLink}>{LogoImage}</a>;
        }

        return <a href={`/${storeCode}-${langCode}`}>{LogoImage}</a>;
    };

    return (
        <Header>
            <Wrap>
                {renderBackToStoreLinkWithLogo()}
                {naviLogo && <NaviInfoIcon onClick={naviTrigger} />}
            </Wrap>
        </Header>
    );
};

export default CheckoutHeader;

CheckoutHeader.propTypes = {
    order: PropTypes.shape({
        items: PropTypes.object,
    }),
    isPartnerStore: PropTypes.bool.isRequired,
    naviLogo: PropTypes.bool,
    naviTrigger: PropTypes.func,
    storeActive: PropTypes.shape({
        logo_url: PropTypes.string,
        code: PropTypes.string,
        activeLanguage: PropTypes.string,
    }),
};

CheckoutHeader.defaultProps = {
    order: {},
    naviLogo: undefined,
    naviTrigger: () => {},
    storeActive: {},
};
